import React from 'react';
// import { INTERNAL_MESSAGE_MAX_TEXTAREA_CONTENT_LENGTH } from '../../../utils/constant';
import classNames from 'classnames';
import './BottomHint.less';

interface IBottomHintProps {
  value: string;
  areaMaxLen: number;
  className?: string;
}

export default function BottomHint({ value, areaMaxLen, className }: IBottomHintProps) {
  const valLen = value ? value.length : 0;
  const classes = classNames('bottom-hint-container', className);
  const colorClass = classNames({'bottom-hint-red': valLen === areaMaxLen});
  return (
    <div className={classes}>
      <span className={colorClass}>{valLen}</span>
      <span>/{areaMaxLen}</span>
    </div>
  );
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/ABSInput/component/BottomHint.tsx